import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  const [activeYear, setActiveYear] = useState<string>('2018');
  const timelineData = [{
    year: '2018',
    title: 'Founding Year',
    description: 'Bright Pixxel Studios was founded as a family business with a mission to provide affordable, high-quality web design services to small businesses.',
    achievement: 'Launched our first 25 client websites',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80'
  }, {
    year: '2020',
    title: 'Growth & Expansion',
    description: 'Expanded our team and service offerings to include e-commerce solutions and advanced SEO services to meet growing client demand.',
    achievement: 'Reached milestone of 200+ websites delivered',
    image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80'
  }, {
    year: '2023',
    title: 'Innovation Focus',
    description: 'Introduced our Website Care Plans and developed our proprietary SEO-first design approach to maximize client results.',
    achievement: 'Achieved 98% client satisfaction rating',
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80'
  }, {
    year: '2025',
    title: 'Looking Forward',
    description: 'Continuing to innovate and grow, with plans to expand our service offerings and maintain our commitment to quality and client success.',
    achievement: 'Target: 1000+ websites and expanding into new markets',
    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80'
  }];
  const handleYearClick = (year: string) => {
    setActiveYear(year);
  };
  const activeTimelineItem = timelineData.find(item => item.year === activeYear);
  return <div className="relative" data-id="element-150">
      {/* Timeline navigation */}
      <div className="flex justify-between mb-8 relative" data-id="element-151">
        <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 dark:bg-gray-700 -translate-y-1/2 z-0" data-id="element-152"></div>
        {timelineData.map((item, index) => <div key={item.year} className="relative z-10" data-id="element-153">
            <motion.button initial={{
          scale: 1
        }} whileHover={{
          scale: 1.1
        }} onClick={() => handleYearClick(item.year)} className={`w-16 h-16 rounded-full flex items-center justify-center font-bold text-lg transition-colors ${activeYear === item.year ? 'bg-[#3AA6F9] text-white' : 'bg-white dark:bg-[#1E1E1E] text-gray-500 dark:text-gray-400 border-2 border-gray-200 dark:border-gray-700'}`} data-id="element-154">
              {item.year}
            </motion.button>
            <p className={`text-sm mt-2 text-center font-medium ${activeYear === item.year ? 'text-[#3AA6F9]' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-155">
              {item.title}
            </p>
          </div>)}
      </div>
      {/* Timeline content */}
      {activeTimelineItem && <motion.div key={activeTimelineItem.year} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.3
    }} className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12" data-id="element-156">
          <div className="bg-white dark:bg-[#1E1E1E] p-6 rounded-xl shadow-md" data-id="element-157">
            <h3 className="text-xl font-semibold mb-4" data-id="element-158">
              {activeTimelineItem.title} ({activeTimelineItem.year})
            </h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-159">
              {activeTimelineItem.description}
            </p>
            <div className="flex items-center" data-id="element-160">
              <div className="w-2 h-2 rounded-full bg-green-500 mr-2" data-id="element-161"></div>
              <p className="text-gray-700 dark:text-gray-200 font-medium" data-id="element-162">
                {activeTimelineItem.achievement}
              </p>
            </div>
          </div>
          <div className="rounded-xl overflow-hidden shadow-md" data-id="element-163">
            <img src={activeTimelineItem.image} alt={`ALT: Bright Pixxel Studios in ${activeTimelineItem.year} - ${activeTimelineItem.title}`} className="w-full h-full object-cover" data-id="element-164" />
          </div>
        </motion.div>}
    </div>;
}